import { Menu } from "@mui/material";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Navigate } from "react-router-dom";
import Cookie from "js-cookie";
import pptxgen from "pptxgenjs";
import React, { Component } from "react";
import Spinner from "../../UIComponents/Spinner/Spinner";
import { RETAIL_STORE_EVACUATIONS } from "../../Utilities/AppData/Evacuations";
import { RETAIL_STORE_HANDOVERS } from "../../Utilities/AppData/Handovers/RetailStoreHandovers";
import { RETAIL_STORE_INCIDENTS } from "../../Utilities/AppData/Incidents/RetailStoreIncidents";
import { RETAIL_STORE_NONCONFORMITIES } from "../../Utilities/AppData/Nonconformities/RetailStoreNonconformities";
import { RETAIL_TRAINING_STORE } from "../../Utilities/AppData/Training/RetailTrainingStore";
import BarChart from "../Charts/BarChart";
import DoughNut from "../Charts/DoughNut";
import PolarChart from "../Charts/PolarChart";
import StackedBar from "../Charts/StackedBar";
import DataTables from "../DataTables";
import Footer from "../Footer";
import Header from "../Header";
import { SAFTEY_STORE } from "../SafetyRegister/SafetyRegisterData";
import LZString from 'lz-string';


class PdfExportStore extends Component {
  constructor(props) {
    super(props);
    //
    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    const menu = user["moduleAccess"];
    this.state = {
      title: this.props.location.state.state.title,
      stores: this.props.location.state.state.stores,
      apiInterface: this.props.location.state.state.apiInterface,
      alerts: [],
      user: menu,
      redirect: null,
      alertno: [],
      ytdCount: this.props.location.state.state.ytdCount,
      storeName: this.props.location.state.state.storeName,
      storeCity: this.props.location.state.state.currentCity,
      loading: false,
      month:
        this.props.location.state.state.month[
          parseInt(this.props.location.state.state.currentMonth) - 1
        ],
      currentMonth: this.props.location.state.state.currentMonth,
      currentyear: this.props.location.state.state.currentyear,
      years: this.props.location.state.state.years,
      multiSearch: this.props.location.state.state.multiSearch,
      tabIndex: this.props.location.state.state.tabIndex,
      storeid: this.props.location.state.state.storeid,
      search: this.props.location.state.state.search,
      proxyjsonIncident: [],
      proxyJsonWeeklyCheckListHandover: [],
      proxyJsonMonthlyCheckListHandover: [],
      proxyjsonHandover: [],
      proxyJsonWeeklyCheckListNonConformities: [],
      proxyJsonMonthlyCheckListNonConformities: [],
      proxyjsonSafetyRegister: [],
      proxyjsonEvacuations: [],
      proxyjsonTraining: [],
      proxyjsonNonConformities: [],
    };
  }

  printDocument = () => {
    /* 
      This is the main functionality in this component, This function creates the PDF
      DivToPrint is the main div which contains all the reports, Incident, Evac, handover, non conf etc.
      This div is then divided in this function into multiple canvas to accomodate the size of A4 sheet.
      The Width, height and functionalities are predefined and can be used to split any div of any size into multiple A4 sheets.
      The function then stores the new canvases in differnt new pdf pages and then once it exits the loop, it saves into a pdf with the given name.
    */
    var box = document.querySelector("#divToPrint");
    var HTML_Width = box.offsetWidth;
    var HTML_Height = box.offsetHeight;
    var top_left_margin = 10;
    var PDF_Width = HTML_Width + top_left_margin * 2;
    var PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
    var canvas_image_width = HTML_Width;
    var canvas_image_height = HTML_Height;

    var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

    html2canvas(document.querySelector("#divToPrint"), {
      scale: 1.5,
    }).then(function (canvas) {
      canvas.getContext("2d");

      //

      var imgData = canvas.toDataURL("image/jpeg");
      var pdf = new jsPDF("p", "pt", [PDF_Width, PDF_Height]);
      pdf.addImage(
        imgData,
        "JPG",
        top_left_margin,
        top_left_margin,
        canvas_image_width,
        canvas_image_height
      );

      for (var i = 1; i <= totalPDFPages; i++) {
        // pdf.addPage(PDF_Width, PDF_Height);
        pdf.addPage();

        pdf.addImage(
          imgData,
          "JPG",
          top_left_margin,
          -(PDF_Height * i) + top_left_margin * 10,
          canvas_image_width,
          canvas_image_height
        );
      }

      pdf.save("Storewise Retail.pdf");
    });
    //this.props.history.goBack();
    this.setState({
      redirect: "/storeDashboardRetail",
    });
    // this.props.navigate('/storeDashboardRetail');
  };

  async pptDownload() {
    /*This function works similarly to the above PDF export function, only difference is that it exports into ppt. 
    instead of new pages being created, new slides are created which once done, is combined into one ppt.
  */
    var pptx = new pptxgen();

    var forPDF = document.querySelectorAll(".PPTDownload");
    var len = forPDF.length;

    for (var i = 0; i < forPDF.length; i++) {
      await html2canvas(forPDF[i], {
        scale: 1.5,
      }).then(function (canvas) {
        var imgData = canvas.toDataURL("image/jpg", 1.0);
        //document.body.append(canvas)
        var test = i;

        var eleHeight = window
          .getComputedStyle(forPDF[i], null)
          .getPropertyValue("height");
        eleHeight = eleHeight.substring(0, eleHeight.length - 2);

        if (eleHeight > 1400) {
          var loop = eleHeight / 900;
          loop = Math.round(loop);
          var lent = 1400;
          var pos = 0;

          for (var j = 0; j < loop; j++) {
            var ctx = canvas.getContext("2d");

            var a = { x: 0, y: pos };
            var b = { x: canvas.width, y: lent };
            // get the image data you want to keep.
            var imageData = ctx.getImageData(a.x, a.y, b.x, b.y);

            // create a new cavnas same as clipped size and a context
            var newCan = document.createElement("canvas");
            newCan.width = b.x - a.x;
            newCan.height = b.y - a.y;
            var newCtx = newCan.getContext("2d");

            // put the clipped image on the new canvas.
            newCtx.putImageData(imageData, 0, 0);

            imgData = newCan.toDataURL("image/jpg", 1.0);
            var slide = pptx.addSlide();
            slide.addImage({ data: imgData, x: 2.0, y: 0.1, w: 5.0, h: 5.0 });
            pos = lent;
            lent = lent + 1400;
          }
        } else {
          var slide = pptx.addSlide();
          slide.addImage({ data: imgData, x: 2.0, y: 0.1, w: 5.0, h: 5.0 });
        }
        if (i + 1 === len) {
          pptx.writeFile("StoreWiseRetail");
        }
      });
    }
    //this.props.history.goBack();
    this.setState({
      redirect: "/storeDashboardRetail",
    });
    // this.props.navigate('/storeDashboardRetail');
  }

  //async pptDownload() {
  /* 
      This function works similarly to the above PDF export function, only difference is that it exports into ppt. 
      instead of new pages being created, new slides are created which once done, is combined into one ppt.
    */
  /*  var pptx = new pptxgen();

    var forPDF = document.querySelectorAll('.PPTDownload');
    var len = forPDF.length;
    //
    for (let i = 0; i < forPDF.length; i++) {
      var slide = pptx.addSlide();
      //
      await html2canvas(forPDF[i], {
        scale: 1.5,
      }).then(function (canvas) {
        var imgData = canvas.toDataURL('image/jpg', 1.0);
        //document.body.append(canvas)
        //
        slide.addImage({ data: imgData, x: 2.0, y: 0.1, w: 5.0, h: 5.0 });
        if (i + 1 == len) {
          pptx.writeFile('StoreWiseRetail');
        }
      });
    }

    this.props.navigate('/dashboardRetail');
  } */

  handleSelect(
    /* 
      The data for the ppt and pdfs are acquired in this function. If any of the function fails, the page is made to auto refresh to avoid blank pages
    */
    month = this.state.currentMonth,
    year = this.state.currentyear,
    storeid = this.state.storeid
  ) {
    this.setState({
      loading: true,
      graph: false,
    });

    RETAIL_STORE_EVACUATIONS("/fetchStoreWiseEvacuationReport", storeid, year)
      .then((response) => {
        if (
          response.errorMessage === "Token Expired" ||
          response.errorMessage === "Invalid Token:::JWT expired" ||
          response.errorMessage ===
            "Your session has expired. Please login again."
        ) {
          Cookie.remove("currentUser");
          Cookie.remove("stores");
          Cookie.remove("storesAll");
          Cookie.remove("warehouses");

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              "Your session has been expired and you will be redirected to the login page!!",
          });
          setTimeout(() => {
            return (window.location = "/");
          }, 4000);
        }
        this.setState({
          storeDashboard: true,
          proxyjsonEvacuations: response,
        });
        RETAIL_STORE_INCIDENTS(
          "/fetchStoreWiseIncidentReport",
          storeid,
          month,
          year
        )
          .then((response) => {
            this.setState({
              ytdCount: response.ytdCount,
              storeDashboard: true,
              alerts: response.stores,
              alertno: response.mic,
              proxyjsonIncident: response,
            });
            RETAIL_STORE_HANDOVERS(
              "/fetchHandoverStorewiseDashBoards",
              storeid,
              month,
              year
            )
              .then((response) => {
                this.setState({
                  storeDashboard: true,
                  proxyjsonHandover: response["proxyjson"],
                  proxyJsonWeeklyCheckListHandover:
                    response["proxyJsonWeeklyCheckList"],
                  proxyJsonMonthlyCheckListHandover:
                    response["proxyJsonMonthlyCheckList"],
                });
                RETAIL_STORE_NONCONFORMITIES(
                  "/fetchStorewiseNonConfirmityDashboardRetail",
                  storeid,
                  month,
                  year
                )
                  .then((response) => {
                    this.setState({
                      storeDashboard: true,
                      graph: true,
                      proxyjsonNonConformities: response["proxyjson"],
                      proxyJsonWeeklyCheckListNonConformities:
                        response["proxyJsonWeeklyCheckList"],
                    });
                  })
                  .catch(() => {
                    this.setState({
                      // loading: false,
                      modalOpen: true,
                      message:
                        "Unable to retrieve the data. Please try again later",
                    });
                  });
              })
              .catch(() => {
                this.setState({
                  //loading: false,
                  modalOpen: true,
                  message:
                    "Unable to retrieve the data. Please try again later",
                });
              });
          })
          .catch(() => {
            this.setState({
              //loading: false,
              modalOpen: true,
              message: "Unable to retrieve the data. Please try again later",
            });
          });
      })
      .catch(() => {
        this.setState({
          // loading: false,
          modalOpen: true,
          message: "Unable to retrieve the data. Please try again later",
        });
      });
    SAFTEY_STORE("/loadSafetyRegisterStorewiseDashboard", year, storeid)
      .then((response) => {
        this.setState({
          proxyjsonSafetyRegister: response,
        });
      })
      .catch(() => {
        this.setState({
          //loading: false,
          modalOpen: true,
          message: "Unable to retrieve the data. Please try again later",
        });
      });
    setTimeout(() => {
      RETAIL_TRAINING_STORE(
        "/fetchTrainingMonthWiseDashboardRetail",
        month,
        storeid
      )
        .then((response) => {
          this.setState({
            proxyjsonTraining: response,
            loading: false,
          });
          //
        })
        .catch(() => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: "Unable to retrieve the data. Please try again later",
          });
          //
        });
    }, 6000);
  }

  goBack = () => {
    //this.props.history.goBack();
    this.setState({
      redirect: "/storeDashboardRetail",
    });
  };

  componentDidMount() {
    localStorage.setItem("currentStoreForDashboardStore", this.state.storeid);
    localStorage.setItem(
      "currentStoreForDashboardStoreName",
      this.state.storeName
    );
    localStorage.setItem("cityForDashboardStore", this.state.storeCity);

    this.handleSelect();
  }

  render() {
    if (this.state.redirect) {
      return (
       
        <Navigate
        to={this.state.redirect}
        state={{
             tabIndex: this.state.tabIndex,
              storeName: this.state.storeName,
              storeId: this.state.storeid,
              currentCity: this.state.storeCity,
              month: this.state.currentMonth,
              year: this.state.currentyear,
              fromPdf: true,
        }}
      />
      );
    }
    const { loading, currentMonth, currentyear } = this.state;
    var ndate = new Date().toJSON().slice(0, 10);
    var date =
      ndate.slice(8, 10) + "/" + ndate.slice(5, 7) + "/" + ndate.slice(0, 4);
    //alert(JSON.stringify(this.state.proxyJsonWeeklyCheckListNonConformities));
    let future = this.state.user;

    let pageAllow = false;
    return (
      <div style={{ background: "white" }}>
        {future.map((val, index) =>
          val.value == 1
            ? val.featureAccess
              ? val.featureAccess.map((child1, ind) =>
                  child1.value == 1
                    ? child1.featureName == "Store Dashboard"
                      ? (pageAllow = true)
                      : ""
                    : ""
                )
              : ""
            : ""
        )}
        {pageAllow === false ? (
       
          <Navigate to="/pageNotAllowed" state={{ id:'PDF Export' }} />
        ) : (
          ""
        )}
        <Header title="PDF Export" />
        <Menu />
        {loading ? (
          <Spinner />
        ) : (
          <section>
            <div
              className="row"
              style={{
                width: "270mm",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <div className="col-md-12 mt-60 alignrow">
                <button
                  type="button"
                  className="btn btn-secondary deca-btn-orange"
                  onClick={this.goBack}
                  style={{
                    cursor: "pointer",
                    // float: 'left',
                    // marginTop: '40px',
                    // marginLeft: '250px',
                  }}
                >
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
                <div>
                  <button
                    onClick={() => this.pptDownload()}
                    className="deca-btn-yellow"
                    style={{ marginRight: "10px" }}
                  >
                    Export to PPT
                  </button>
                  <button
                    onClick={() => this.printDocument()}
                    className="deca-btn-yellow"
                    style={{ marginRight: "20px" }}
                  >
                    Export to PDF
                  </button>
                </div>
              </div>
            </div>
            <div
              id="divToPrint"
              className="mt4"
              style={{
                background: "white",
                width: "270mm",
                Height: "297mm",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              {/* 
                
                Each Report tabs are given the dimensions of A4 sheet to avoid overlapping. These divs are then given a header with Decathlon logo.
                Removing the A4 style will not affect the functionality but if there are graphs/tables with more data, these will get leaked into another page and 
                will not be handled/displayed properly.

                */}
              {/*******  Non Conformities Report start   ***********/}
              <div
                className="PPTDownload"
                style={{
                  background: "white",
                  width: "270mm",
                  minHeight: "297mm",
                  marginLeft: "auto",
                  marginRight: "auto",
                  // marginTop: '70px',
                }}
              >
                <div
                  className="row"
                  style={{ borderBottom: "0.5px black dotted" }}
                >
                  <div className="col-md-2">
                    <img
                      alt="decalogo"
                      src={require("./logodecath.png")}
                      style={{ padding: "10px" }}
                      width="150"
                      height="50"
                    ></img>
                  </div>
                  <div className="col-md-10">
                    <p
                      style={{
                        textAlign: "right",
                        fontSize: "15px",
                        padding: "10px",
                      }}
                    >
                      {" "}
                      {this.state.title +
                        "-" +
                        this.state.storeName +
                        " " +
                        " " +
                        date}{" "}
                    </p>
                  </div>
                </div>
                <h3
                  style={{
                    textDecoration: "underline",
                    fontWeight: "bold",
                  }}
                >
                  {" "}
                  <span
                    style={{
                      display: "inline-block",
                      borderBottom: "2px solid black",
                      paddingBottom: "4px",
                    }}
                  >
                    Non Conformities Report {this.state.month}-
                    {this.state.currentyear}
                  </span>
                </h3>

                <div>
                  <DataTables
                    title="Nonconformities"
                    storeDashboard={true}
                    data={this.state.proxyJsonWeeklyCheckListNonConformities}
                    name="StorewiseNonconformities"
                    storeid={this.state.storeid}
                    dataClick={"Noncoformities"}
                    year={currentyear}
                    month={currentMonth}
                  />
                  <StackedBar
                    mainTitle="Points Open and Points Closed"
                    title={["Points Open", "Points Closed"]}
                    label={this.state.proxyjsonNonConformities.stores}
                    data={[
                      this.state.proxyJsonWeeklyCheckListNonConformities
                        .totalOpenCount,
                      this.state.proxyJsonWeeklyCheckListNonConformities
                        .totalCloseCount,
                    ]}
                  />
                </div>
                <div className="row">
                  <div></div>
                </div>
              </div>
              <br></br>
              <div
                className="PPTDownload"
                style={{
                  background: "white",
                  width: "210mm",
                  minHeight: "297mm",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginTop: "70px",
                }}
              >
                <div
                  className="row"
                  style={{ borderBottom: "0.5px black dotted" }}
                >
                  <div className="col-md-2">
                    <img
                      alt="decalogo"
                      src={require("./logodecath.png")}
                      style={{ padding: "10px" }}
                      width="150"
                      height="50"
                    ></img>
                  </div>
                  <div className="col-md-10">
                    <p
                      style={{
                        textAlign: "right",
                        fontSize: "15px",
                        padding: "10px",
                      }}
                    >
                      {" "}
                      {this.state.title +
                        "-" +
                        this.state.storeName +
                        " " +
                        " " +
                        date}{" "}
                    </p>
                  </div>
                </div>
                <div>
                  {/* <DataTables
                    title='Nonconformities'
                    storeDashboard={true}
                    data={this.state.proxyJsonWeeklyCheckListNonConformities}
                    name='StorewiseNonconformities'
                    storeid={this.state.storeid}
                    year={currentyear}
                    month={currentMonth}
                  /> */}

                  {this.state.graph ? (
                    <PolarChart
                      title="Non Confirm Points"
                      name={true}
                      labels={
                        this.state.proxyJsonWeeklyCheckListNonConformities
                          ? this.state.proxyJsonWeeklyCheckListNonConformities.dhead.slice(
                              1
                            )
                          : null
                      }
                      data={
                        this.state.proxyJsonWeeklyCheckListNonConformities
                          .graphData[currentMonth - 1]
                      }
                    />
                  ) : null}
                </div>
              </div>
              {/*******  Non Conformities Report End   ***********/}
              <br></br>
              {/*******   Safety Register Report start   ***********/}
              <div
                className="PPTDownload"
                style={{
                  background: "white",
                  width: "210mm",
                  minHeight: "297mm",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginTop: "70px",
                }}
              >
                <div
                  className="row"
                  style={{ borderBottom: "0.5px black dotted" }}
                >
                  <div className="col-md-2">
                    <img
                      alt="decalogo"
                      src={require("./logodecath.png")}
                      style={{ padding: "10px" }}
                      width="150"
                      height="50"
                    ></img>
                  </div>
                  <div className="col-md-10">
                    <p
                      style={{
                        textAlign: "right",
                        fontSize: "15px",
                        padding: "10px",
                      }}
                    >
                      {" "}
                      {this.state.title +
                        "-" +
                        this.state.storeName +
                        " " +
                        " " +
                        date}{" "}
                    </p>
                  </div>
                </div>

                <h3
                  style={{
                    textDecoration: "underline",
                    fontWeight: "bold",
                  }}
                >
                  {" "}
                  <span
                    style={{
                      display: "inline-block",
                      borderBottom: "2px solid black",
                      paddingBottom: "4px",
                    }}
                  >
                    Compliance & Contracts Report {this.state.month}-
                    {this.state.currentyear}
                  </span>
                </h3>

                <div>
                  <DataTables
                    title="Nonconformities"
                    storeDashboard={true}
                    data={this.state.proxyjsonSafetyRegister}
                    name="StorewiseNonconformities"
                    storeid={this.state.storeid}
                    year={currentyear}
                    month={currentMonth}
                  />
                </div>
              </div>
              {/*******   Safety Register Report End   ***********/}
              <br></br>
              {/*******  Handover Report start   ***********/}
              <div
                className="PPTDownload"
                style={{
                  background: "white",
                  width: "210mm",
                  minHeight: "297mm",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginTop: "70px",
                }}
              >
                <div
                  className="row"
                  style={{ borderBottom: "0.5px black dotted" }}
                >
                  <div className="col-md-2">
                    <img
                      alt="decalogo"
                      src={require("./logodecath.png")}
                      style={{ padding: "10px" }}
                      width="150"
                      height="50"
                    ></img>
                  </div>
                  <div className="col-md-10">
                    <p
                      style={{
                        textAlign: "right",
                        fontSize: "15px",
                        padding: "10px",
                      }}
                    >
                      {" "}
                      {this.state.title +
                        "-" +
                        this.state.storeName +
                        " " +
                        " " +
                        date}{" "}
                    </p>
                  </div>
                </div>
                <h3
                  style={{
                    textDecoration: "underline",
                    fontWeight: "bold",
                  }}
                >
                  {" "}
                  <span
                    style={{
                      display: "inline-block",
                      borderBottom: "2px solid black",
                      paddingBottom: "4px",
                    }}
                  >
                    Handover Report {this.state.month}-{this.state.currentyear}
                  </span>
                </h3>

                <div>
                  <DataTables
                    title="Handovers"
                    storeDashboard={true}
                    data={this.state.proxyjsonHandover}
                    name="StorewiseHandovers"
                    storeid={this.state.storeid}
                    year={currentyear}
                    month={currentMonth}
                  />
                </div>
                <div className="row">
                  <div className="col-md-8">
                    <DataTables
                      title="Handovers"
                      storeDashboard={true}
                      data={this.state.proxyJsonWeeklyCheckListHandover}
                      name="StorewiseHandovers"
                      storeid={this.state.storeid}
                      year={currentyear}
                      month={currentMonth}
                    />
                    <DataTables
                      title="Handovers"
                      storeDashboard={true}
                      data={this.state.proxyJsonMonthlyCheckListHandover}
                      name="HandoversMonthlyBSU"
                      storeid={this.state.storeid}
                      year={currentyear}
                      month={currentMonth}
                    />
                  </div>
                </div>
              </div>
              {/*******  Handover Report End   ***********/}
              <br></br>
              {/*******   Training Report start   ***********/}
              <div
                className="PPTDownload"
                style={{
                  background: "white",
                  width: "210mm",
                  minHeight: "297mm",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginTop: "70px",
                  marginBottom: "50px",
                }}
              >
                <div
                  className="row"
                  style={{ borderBottom: "0.5px black dotted" }}
                >
                  <div className="col-md-2">
                    <img
                      alt="decalogo"
                      src={require("./logodecath.png")}
                      style={{ padding: "10px" }}
                      width="150"
                      height="50"
                    ></img>
                  </div>
                  <div className="col-md-10">
                    <p
                      style={{
                        textAlign: "right",
                        fontSize: "15px",
                        padding: "10px",
                      }}
                    >
                      {" "}
                      {this.state.title +
                        "-" +
                        this.state.storeName +
                        " " +
                        " " +
                        date}{" "}
                    </p>
                  </div>
                </div>
                <h3
                  style={{
                    textDecoration: "underline",
                    fontWeight: "bold",
                  }}
                >
                  {" "}
                  <span
                    style={{
                      display: "inline-block",
                      borderBottom: "2px solid black",
                      paddingBottom: "4px",
                    }}
                  >
                    Training Report {this.state.month}-{this.state.currentyear}
                  </span>
                </h3>

                <div>
                  <DataTables
                    title="Nonconformities"
                    storeDashboard={true}
                    data={this.state.proxyjsonTraining}
                    name="StorewiseNonconformities"
                    storeid={this.state.storeid}
                    year={currentyear}
                    month={currentMonth}
                  />
                </div>
              </div>
              {/*******   Training Report End   ***********/}
              <br />
              <br />

              {/*******  Incident Report Start   ***********/}
              <div
                style={{
                  background: "white",
                  width: "210mm",
                  minHeight: "297mm",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                <div
                  className="row"
                  style={{ borderBottom: "0.5px black dotted" }}
                >
                  <div className="col-md-2">
                    <img
                      alt="decalogo"
                      src={require("./logodecath.png")}
                      style={{ padding: "10px" }}
                      width="150"
                      height="50"
                    ></img>
                  </div>
                  <div className="col-md-10">
                    <p
                      style={{
                        textAlign: "right",
                        fontSize: "15px",
                        padding: "10px",
                      }}
                    >
                      {" "}
                      {this.state.title +
                        "-" +
                        this.state.storeName +
                        " " +
                        " " +
                        date}{" "}
                    </p>
                  </div>
                </div>
                <div>
                  <h3
                    style={{
                      textDecoration: "underline",
                      fontWeight: "bold",
                    }}
                  >
                    {" "}
                    <span
                      style={{
                        display: "inline-block",
                        borderBottom: "2px solid black",
                        paddingBottom: "4px",
                      }}
                    >
                      Incident Report {this.state.month}-
                      {this.state.currentyear}
                    </span>
                  </h3>

                  <div style={{ marginBottom: "100px" }}>
                    <DataTables
                      title="Evacuations"
                      storeDashboard={true}
                      data={this.state.proxyjsonIncident}
                      name="StorewiseEvacuations"
                      storeid={this.state.storeid}
                      year={currentyear}
                      month={currentMonth}
                    />
                  </div>
                </div>
              </div>
              <br></br>
              <div
                className="PPTDownload"
                style={{
                  background: "white",
                  width: "210mm",
                  minHeight: "297mm",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginTop: "70px",
                  marginBottom: "50px",
                }}
              >
                <div
                  className="row"
                  style={{ borderBottom: "0.5px black dotted" }}
                >
                  <div className="col-md-2">
                    <img
                      alt="decalogo"
                      src={require("./logodecath.png")}
                      style={{ padding: "10px" }}
                      width="150"
                      height="50"
                    ></img>
                  </div>
                  <div className="col-md-10">
                    <p
                      style={{
                        textAlign: "right",
                        fontSize: "15px",
                        padding: "10px",
                      }}
                    >
                      {" "}
                      {this.state.title +
                        "-" +
                        this.state.storeName +
                        " " +
                        " " +
                        date}{" "}
                    </p>
                  </div>
                </div>
                <div style={{ padding: "10px", marginBottom: "20px" }}>
                  <BarChart
                    mainTitle="No of Incidents"
                    title={["No of Incidents by Month", "No of Incidents YTD"]}
                    label={this.state.alerts}
                    data={[this.state.alertno, this.state.ytdCount]}
                  />{" "}
                  <DoughNut
                    title="Montly Incidents"
                    name={true}
                    labels={this.state.alerts}
                    data={this.state.alertno}
                  />
                </div>
              </div>
              <br></br>
              <br></br>
              <div
                className="PPTDownload"
                style={{
                  background: "white",
                  width: "210mm",
                  minHeight: "297mm",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginTop: "70px",
                }}
              >
                <div
                  className="row"
                  style={{ borderBottom: "0.5px black dotted" }}
                >
                  <div className="col-md-2">
                    <img
                      alt="decalogo"
                      src={require("./logodecath.png")}
                      style={{ padding: "10px" }}
                      width="150"
                      height="50"
                    ></img>
                  </div>
                  <div className="col-md-10">
                    <p
                      style={{
                        textAlign: "right",
                        fontSize: "15px",
                        padding: "10px",
                      }}
                    >
                      {" "}
                      {this.state.title +
                        "-" +
                        this.state.storeName +
                        " " +
                        " " +
                        date}{" "}
                    </p>
                  </div>
                </div>
                <div style={{ padding: "10px", marginBottom: "20px" }}>
                  <PolarChart
                    title="No of Incidents YTD"
                    name={true}
                    labels={this.state.alerts}
                    data={this.state.ytdCount}
                  />
                </div>
              </div>

              {/*******  Incident Report End   ***********/}
              <br></br>
              {/*******  Evacuation Report Start  ***********/}
              <div
                className="PPTDownload"
                style={{
                  background: "white",
                  width: "210mm",
                  minHeight: "297mm",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginTop: "70px",
                  marginBottom: "90px",
                }}
              >
                <div
                  className="row"
                  style={{ borderBottom: "0.5px black dotted" }}
                >
                  <div className="col-md-2">
                    <img
                      alt="decalogo"
                      src={require("./logodecath.png")}
                      style={{ padding: "10px" }}
                      width="150"
                      height="50"
                    ></img>
                  </div>
                  <div className="col-md-10">
                    <p
                      style={{
                        textAlign: "right",
                        fontSize: "15px",
                        padding: "10px",
                      }}
                    >
                      {" "}
                      {this.state.title +
                        "-" +
                        this.state.storeName +
                        " " +
                        " " +
                        date}{" "}
                    </p>
                  </div>
                </div>

                <h3
                  style={{
                    textDecoration: "underline",
                    fontWeight: "bold",
                  }}
                >
                  {" "}
                  <span
                    style={{
                      display: "inline-block",
                      borderBottom: "2px solid black",
                      paddingBottom: "4px",
                    }}
                  >
                    Evacuation Report {this.state.month}-
                    {this.state.currentyear}
                  </span>
                </h3>
                <div>
                  <DataTables
                    title="Evacuations"
                    storeDashboard={true}
                    data={this.state.proxyjsonEvacuations}
                    name="StorewiseEvacuations"
                    storeid={this.state.storeid}
                    year={currentyear}
                    month={currentMonth}
                  />
                </div>
              </div>
              <br></br>
              {/*******  Evacuation Report End   ***********/}
            </div>
          </section>
        )}

        <Footer />
      </div>
    );
  }
}

export default PdfExportStore;
